// client/src/coms/views/chatview_parts/YouTubePreviewCard.js
import React, { useState } from 'react';

function getYouTubeThumbnail(videoId) {
  if (!videoId) return '';
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}

export default function YouTubePreviewCard({ href, videoId }) {
  const [expanded, setExpanded] = useState(false);

  if (!videoId) {
    return (
      <a href={href}>
        {href}
      </a>
    );
  }

  const thumb = getYouTubeThumbnail(videoId);
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
  const collapsedMax = 560;
  const expandedMax = 920;

  return (
    <div
      style={{
        marginTop: 6,
        marginBottom: 6,
        border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.12 * var(--vx-ov, 1)))',
        borderRadius: 10,
        overflow: 'hidden',
        background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.03 * var(--vx-ov, 1)))',
        width: '100%',
        maxWidth: expanded ? expandedMax : collapsedMax,
        transition: 'max-width 160ms ease',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16 / 9',
          background: '#000',
        }}
      >
        {!expanded ? (
          <button
            type="button"
            onClick={() => setExpanded(true)}
            style={{
              position: 'absolute',
              inset: 0,
              display: 'block',
              width: '100%',
              height: '100%',
              padding: 0,
              margin: 0,
              border: 'none',
              background: 'transparent',
              textAlign: 'left',
              cursor: 'pointer',
            }}
            aria-label="Play YouTube video"
          >
            <img
              src={thumb}
              alt="YouTube thumbnail"
              loading="lazy"
              style={{
                width: '100%',
                height: '100%',
                display: 'block',
                objectFit: 'cover',
                background: '#000',
              }}
            />

            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
              }}
            >
              <div
                style={{
                  width: 62,
                  height: 44,
                  borderRadius: 12,
                  background: 'rgba(0,0,0,0.72)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
                }}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderTop: '10px solid transparent',
                    borderBottom: '10px solid transparent',
                    borderLeft: '15px solid white',
                    marginLeft: 4,
                  }}
                />
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'rgba(0,0,0,0.7)',
                border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.12 * var(--vx-ov, 1)))',
                color: 'white',
                fontSize: 12,
                borderRadius: 999,
                padding: '4px 8px',
                lineHeight: 1,
                pointerEvents: 'none',
              }}
            >
              Play
            </div>
          </button>
        ) : (
          <iframe
            src={embedUrl}
            title={`YouTube video ${videoId}`}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
              background: '#000',
            }}
          />
        )}
      </div>

      <div
        style={{
          padding: '8px 10px',
          borderTop: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.08 * var(--vx-ov, 1)))',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexWrap: 'wrap',
        }}
      >
        <a
          href={href}
          style={{
            fontSize: 12,
            opacity: 0.85,
            wordBreak: 'break-all',
            flex: '1 1 220px',
          }}
        >
          {href}
        </a>

        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          style={{
            height: 26,
            padding: '0 10px',
            fontSize: 12,
            borderRadius: 6,
            border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.2 * var(--vx-ov, 1)))',
            background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.05 * var(--vx-ov, 1)))',
            color: 'inherit',
            cursor: 'pointer',
          }}
        >
          {expanded ? 'Collapse' : 'Expand'}
        </button>
      </div>
    </div>
  );
}